











































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component
export default class ComponentModalActionConfirm extends Vue {
  @Prop() visible: boolean
  @Prop() title: string
  @Prop() subtitle: string
  @Prop() description: string

  show: boolean = false

  @Emit('close')
  closeModal() {
    this.show = false
  }

  @Emit('esc')
  escClick() {
    this.close()
  }

  @Emit('confirm')
  confirmClick() {
    this.close()
  }

  @Emit('decline')
  declineClick() {
    this.close()
  }

  @Watch('visible')
  onVisibilityChange(visible: boolean) {
    this.show = visible
  }

  close() {
    this.$emit('close')
  }

  esc() {
    this.close()
    this.$emit('esc')
  }
}
